export default __webpack_public_path__ + "static/media/project3.15218516.png";